<template>
  <div v-if="isError" class="menu">
    <h2 class="section-title m-4 text-center text-lg">
      通信エラーが発生しました
    </h2>
    <div class="mt-4 px-4">
      <a @click="reload" class="button-secondary block button-icon icon-left">
        <span>再読み込み</span>
      </a>
    </div>
    <div class="mt-4 px-4">
      <a :href="maas_top_url()" class="button-secondary block button-icon icon-left">
        <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="m10 3.20710678v6.29289322c0 .27614237-.22385763.5-.5.5h-6.29289322c-.27614237 0-.5-.22385763-.5-.5 0-.13260824.05267842-.2597852.14644661-.35355339l6.29289322-6.29289322c.19526215-.19526215.51184463-.19526215.70710678 0 .09376819.09376819.14644661.22094515.14644661.35355339z" fill-rule="evenodd" transform="matrix(-.70710678 -.70710678 -.70710678 .70710678 16.485281 10)"/></svg>
        <span>TOPに戻る</span>
      </a>
    </div>
  </div>
  <div v-else class="menu">
    <div class="absolute mt-4">
      <a :href="maas_top_url()" class="flex border border-link rounded text-link ml-2 mr-3 px-2 py-1 bg-white">
        <span class="flex justify-center items-center text-sm whitespace-nowrap">戻る</span>
      </a>
    </div>
    <h2 class="section-title mt-4 mb-2 text-center text-lg">
      {{ getDemandName() }}
    </h2>
    <h2 class="section-title text-center text-lg">
      予約状況
    </h2>
    <template v-if="showSummary && getReservationsSummry().length > 0">
      <div v-for="reservation in getReservationsSummry()" :key="reservation.id">
        <div class="mx-2 px-2 bg-white rounded-md mb-2 mt-2 border-gray-300 border" :class="[isUsableReservation(reservation.status) ? '':'bg-gray-200']" @click="open(reservation)">
          <div class="border-gray-300 border-b">
            <div class="px-1 pt-1 float-left w-28 text-gray-500">
              予約番号
            </div>
            <div v-if="isToday(reservation)" class="float-right w-12 h-4 mt-1.5 rounded bg-red-400 text-center text-xs font-semibold text-white">
              本日
            </div>
            <div class="px-1 ml-28 pt-1">
              {{ reservation.id }}
            </div>
          </div>
          <div class="border-gray-300 border-b">
            <div class="px-1 float-left w-28 text-gray-500">
              乗車予定日時
            </div>
            <div class="px-1 ml-28">
              {{ getDatetime(reservation.latestEstimatePickUpTime) }}
            </div>
          </div>
          <div class="pb-1">
            <div class="px-1 float-left w-28 text-gray-500">
              乗車場所
            </div>
            <div class="px-1 ml-28">
              {{ reservation.pickUpLocationName }}
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="showSummary">
      <h2 class="m-4 text-center text-md">
        乗車前の予約はありません
      </h2>
    </template>
    <template v-if="showSummary && reservations.length > 0">
      <div v-if="showSummary" class="px-4 text-right font-semibold text-link" @click="showAllReservations">
        すべての予約を見る
      </div>
    </template>
    <template v-if="!showSummary && reservations.length > 0">
      <div class="mx-2 mt-2 reservations-select border-gray-300 border">
        <select v-model="condition" class="px-2 mb-2" @change="onStatusChange">
          <option v-for="condition in conditions" v-bind:key="condition.id" v-bind:value="condition.id">
            {{ condition.name }}
          </option>
        </select>
      </div>
      <div v-if="getReservationsList().length > 0">
        <div v-for="reservation in getReservationsList().slice(0, maxReservations)" :key="reservation.id" class="mx-2 px-2 bg-white rounded-md mb-2 mt-2 border-gray-300 border" :class="[isUsableReservation(reservation.status) ? '':'bg-gray-200']">
          <div class="border-gray-300 border-b-2">
            <div class="px-1 pt-2 float-left w-28 text-gray-500">
              予約番号
            </div>
            <div class="px-1 ml-28 pt-2">
              {{ reservation.id }}
            </div>
          </div>
          <div class="border-gray-300 border-b-2">
            <div class="px-1 float-left w-28 text-gray-500">
              ステータス
            </div>
            <div class="px-1 ml-28">
              {{ getStatus(reservation.status) }}
            </div>
          </div>
          <div class="border-gray-300 border-b-2">
            <div class="px-1 float-left w-28 text-gray-500">
              乗車予定日時
            </div>
            <div class="px-1 ml-28">
              {{ getDatetime(reservation.latestEstimatePickUpTime) }}
            </div>
          </div>
          <div class="border-gray-300 border-b-2">
            <div class="px-1 float-left w-28 text-gray-500">
              乗車場所
            </div>
            <div class="px-1 ml-28">
              {{ reservation.pickUpLocationName }}
            </div>
          </div>
          <div class="border-gray-300 border-b-2">
            <div class="px-1 float-left w-28 text-gray-500">
              降車場所
            </div>
            <div class="px-1 ml-28">
              {{ reservation.dropOffLocationName }}
            </div>
          </div>
          <div class="border-gray-300 border-b-2">
            <div class="px-1 float-left w-28 text-gray-500">
              車両番号
            </div>
            <div class="px-1 ml-28">
              {{ reservation.savName }}
            </div>
          </div>
          <div class="">
            <div class="px-1 float-left w-28 text-gray-500">
              乗車人数
            </div>
            <div class="px-1 ml-28">
              <span v-if=" reservation.seatCountForAdult > 0">おとな{{ reservation.seatCountForAdult }}名</span>
              <span v-if=" reservation.seatCountForChild > 0">
                <span v-if=" reservation.seatCountForAdult > 0">、</span>
                こども{{ reservation.seatCountForChild }}名
              </span>
            </div>
          </div>
          <div class="pb-2">
            <div v-if="isUsableReservation(reservation.status)" class="mt-2 px-6">
              <a @click="open(reservation)" class="button-primary block">
              <span>
                予約を確認する
              </span>
            </a>
            </div>
          </div>
        </div>
        <div v-if="getReservationsList().length > maxReservations" class="px-4 text-center font-semibold text-link" @click="addMaxReservations">
          もっと見る
        </div>
      </div>
      <div v-else>
        <h2 class="m-4 text-center text-md">
          該当する予約はありません
        </h2>
      </div>
      <div class="px-4 text-right font-semibold text-link" @click="showAllReservations">
        乗車前の予約のみ表示
      </div>
    </template>
    <div v-if="showNewReserve()" class="mt-4 px-4">
      <a :href="reserve_url()" class="button-secondary block button-icon icon-right">
        <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="m10 3.20710678v6.29289322c0 .27614237-.22385763.5-.5.5h-6.29289322c-.27614237 0-.5-.22385763-.5-.5 0-.13260824.05267842-.2597852.14644661-.35355339l6.29289322-6.29289322c.19526215-.19526215.51184463-.19526215.70710678 0 .09376819.09376819.14644661.22094515.14644661.35355339z" fill-rule="evenodd" transform="matrix(.70710678 -.70710678 .70710678 .70710678 -.485281 10)"/></svg>
        <span>新規予約</span>
      </a>
    </div>
    <div v-else class="mt-4 px-4">
      <div class="button-secondary block button-icon icon-right bg-gray-400 text-gray-600">
        <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="m10 3.20710678v6.29289322c0 .27614237-.22385763.5-.5.5h-6.29289322c-.27614237 0-.5-.22385763-.5-.5 0-.13260824.05267842-.2597852.14644661-.35355339l6.29289322-6.29289322c.19526215-.19526215.51184463-.19526215.70710678 0 .09376819.09376819.14644661.22094515.14644661.35355339z" fill-rule="evenodd" transform="matrix(.70710678 -.70710678 .70710678 .70710678 -.485281 10)"/></svg>
        <span>新規予約</span>
      </div>
    </div>
    <div v-if="ticket_buy_url()" class="mt-4 px-4">
      <a :href="ticket_buy_url()" class="button-secondary block button-icon icon-right">
        <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="m10 3.20710678v6.29289322c0 .27614237-.22385763.5-.5.5h-6.29289322c-.27614237 0-.5-.22385763-.5-.5 0-.13260824.05267842-.2597852.14644661-.35355339l6.29289322-6.29289322c.19526215-.19526215.51184463-.19526215.70710678 0 .09376819.09376819.14644661.22094515.14644661.35355339z" fill-rule="evenodd" transform="matrix(.70710678 -.70710678 .70710678 .70710678 -.485281 10)"/></svg>
        <span>チケット購入</span>
      </a>
    </div>
    <div v-if="ticket_check_url()" class="mt-4 px-4">
      <a :href="ticket_check_url()" class="button-secondary block button-icon icon-right">
        <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="m10 3.20710678v6.29289322c0 .27614237-.22385763.5-.5.5h-6.29289322c-.27614237 0-.5-.22385763-.5-.5 0-.13260824.05267842-.2597852.14644661-.35355339l6.29289322-6.29289322c.19526215-.19526215.51184463-.19526215.70710678 0 .09376819.09376819.14644661.22094515.14644661.35355339z" fill-rule="evenodd" transform="matrix(.70710678 -.70710678 .70710678 .70710678 -.485281 10)"/></svg>
        <span>マイチケット</span>
      </a>
    </div>
    <div class="mt-4 px-4">
      <a :href="demand_detail_url()" class="button-secondary block button-icon icon-right">
        <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="m10 3.20710678v6.29289322c0 .27614237-.22385763.5-.5.5h-6.29289322c-.27614237 0-.5-.22385763-.5-.5 0-.13260824.05267842-.2597852.14644661-.35355339l6.29289322-6.29289322c.19526215-.19526215.51184463-.19526215.70710678 0 .09376819.09376819.14644661.22094515.14644661.35355339z" fill-rule="evenodd" transform="matrix(.70710678 -.70710678 .70710678 .70710678 -.485281 10)"/></svg>
        <span>オンデマンド交通とは</span>
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import Constants from "../constants";
moment.tz.setDefault('Asia/Tokyo');

export default {
  name: 'reservations',
  data () {
    return {
      condition: "reservation",
      conditions: [],
      isError: false,
      showSummary: true,
      today: parseInt(moment().format('YYYYMMDD'), 10),
      maxReservations: Constants.MAX_RESERVATIONS_COUNT
    }
  },
  mounted () {
    this.getReservations()
    const areaId = this.$store.getters['user/getAreaId']
    const mobilityId = this.$route.query.mobilityId
    if (mobilityId === 'karuizawa003' || areaId === 'kaiyukaruizawa') {
      this.conditions = [
        {
          id: "all",
          name: "すべて"
        },
        {
          id: "reservation",
          name: "乗車前"
        },
        {
          id: "boarded",
          name: "乗車中・降車済"
        },
        {
          id: "canceled",
          name: "キャンセル済"
        }
      ]
    } else {
      this.conditions = [
        {
          id: "all",
          name: "すべて"
        },
        {
          id: "reservation",
          name: "予約中(乗車前)"
        },
        {
          id: "boarded",
          name: "乗車済"
        },
        {
          id: "canceled",
          name: "キャンセル済"
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      reservations: 'reservations/getAll',
      token: 'user/getToken'
    })
  },
  methods: {
    getReservations: function () {
      this.$store.dispatch('loading/beginLoading')
      if (this.$store.getters['user/getToken'] !== null) {
        this.$store.dispatch('reservations/fetchAll', { areaId: this.$route.params.areaId, mobilityId: this.$route.query.mobilityId, statuses: "PICKING_UP,BOARDING,FINISHED,CANCELED"  })
          .then(() => {
            this.isError = false
          })
          .catch(() => {
            this.isError = true
          })
          .finally(() => {
            this.$store.dispatch('loading/endLoading')
          })
      }
    },
    getDatetime: function (time) {
      const d = moment(time)
      return d.format('YYYY/MM/DD HH:mm');
    },
    isVisible: function (status) {
      if (this.condition === "all") {
        if (status === "PICKING_UP" || status === "BOARDING" || status === "FINISHED" || status === "CANCELED") {
          return true
        }
      } else if (this.condition === "reservation") {
        if (status === "PICKING_UP") {
          return true
        }
      } else if (this.condition === "boarded") {
        if (status === "BOARDING" || status === "FINISHED") {
          return true
        }
      } else if (this.condition === "canceled") {
        if (status === "CANCELED") {
          return true
        }
      }
    },
    getReservationsList: function () {
      return this.reservations.filter(r => this.isVisible(r.status))
    },
    onStatusChange: function () {
      this.maxReservations = Constants.MAX_RESERVATIONS_COUNT
    },
    addMaxReservations: function () {
      this.maxReservations += Constants.MAX_RESERVATIONS_COUNT
    },
    getReservationsSummry: function () {
      return this.reservations.filter(r => r.status === "PICKING_UP" && parseInt(moment(r.latestEstimatePickUpTime).format('YYYYMMDD'), 10) >= this.today)
    },
    isToday: function (reservation) {
      return parseInt(moment(reservation.latestEstimatePickUpTime).format('YYYYMMDD'), 10) === this.today
    },
    showAllReservations: function () {
      this.showSummary = !this.showSummary
    },
    getStatus: function(status) {
      const messages = {
        PENDING: "配車計算待ち",
        ASSIGNING: "配車計算中",
        ASSIGNED: "配車計算完了",
        BOARDING: "乗車中",
        FINISHED: "降車済み",
        CANCELED: "キャンセル済み",
        DECLINED: "キャンセル済み",
        DENIED: "配車失敗",
        PICKING_UP: "迎車中",
      };
      return messages[status];
    },
    isExistUsableReservations() {
      if (!this.reservations) return false
      const usableReservation = this.reservations.filter(function(r) {
        return (r.status == 'PICKING_UP') || (r.status == 'BOARDING')
      })
      if (usableReservation.length > 0) {
        return true
      } else {
        return false
      }
    },
    isUsableReservation(status) {
      const areaId = this.$store.getters['user/getAreaId']
      const mobilityId = this.$route.query.mobilityId
      if (mobilityId === 'karuizawa003' || areaId === 'kaiyukaruizawa') {
        if (status !== 'CANCELED') {
          return true
        } else {
          return false
        }
      } else {
        if ((status == 'PICKING_UP') || (status == 'BOARDING')) {
          return true
        } else {
          return false
        }
      }
    },
    maas_top_url: function () {
      const areaId = this.$store.getters['user/getAreaId']
      if (areaId == Constants.DEFAULT_AREA_ID) {
        return Constants.LINK_BASE_URL + '/'
      } else {
        return Constants.LINK_BASE_URL + '/' + areaId
      }
    },
    ticket_check_url: function () {
      const areaId = this.$store.getters['user/getAreaId']
      const mobilityId = this.$route.query.mobilityId
      if (mobilityId === 'karuizawa003' || areaId === 'kaiyukaruizawa') {
        return false
      } else if (areaId == Constants.DEFAULT_AREA_ID) {
        return Constants.LINK_BASE_URL + '/?userTicket=index'
      } else {
        return Constants.LINK_BASE_URL + '/' + areaId + '/?userTicket=index'
      }
    },
    ticket_buy_url: function () {
      const env_key = process.env.VUE_APP_LINK_BASE_ENV || process.env.NODE_ENV
      const areaId = this.$store.getters['user/getAreaId']
      const mobilityId = this.$route.query.mobilityId
      if (mobilityId === 'karuizawa003' || areaId === 'kaiyukaruizawa') {
        return false
      } else if (mobilityId === 'kakunodate001') {
        return Constants.LINK_BASE_URL + '/tohoku/tickets?area=' + (env_key === 'production' ? '481' : '697')
      } else {
        return Constants.LINK_BASE_URL + '/tohoku/tickets?area=' + (env_key === 'production' ? '490' : '2917')
      }
    },
    getDemandName: function () {
      const areaId = this.$route.params.areaId || this.$route.params.poiId
      const mobilityId = this.$route.query.mobilityId
      if (mobilityId === 'kakunodate001') {
        return 'よぶのる角館'
      } else if (mobilityId === 'karuizawa003' || areaId === 'kaiyukaruizawa') {
        return 'よぶのる軽井沢'
      } else {
        return 'よぶのる一関'
      }
    },
    open: function (reservation) {
      if (this.$route.query.mobilityId) {
        location.href = Constants.DEMAND_LINK_URL + 'demand/' + reservation.id + '?mobilityId=' + this.$route.query.mobilityId + '&token=' + this.token
      } else {
        location.href = Constants.DEMAND_LINK_URL + 'demand/' + reservation.id + '?mobilityId=ichinoseki001&token=' + this.token
      }
    },
    reserve_url: function () {
      if (this.$route.query.mobilityId) {
        return Constants.DEMAND_LINK_URL + 'create?mobilityId=' + this.$route.query.mobilityId + '&token=' + this.token
      } else {
        return Constants.DEMAND_LINK_URL + 'create?mobilityId=ichinoseki001&token=' + this.token
      }
    },
    demand_detail_url: function () {
      const areaId = this.$route.params.areaId || this.$route.params.poiId
      const mobilityId = this.$route.query.mobilityId
      if (mobilityId === 'kakunodate001') {
        return Constants.LINK_BASE_URL + '/tohoku/services/yobunoru-kakunodate'
      } else if (mobilityId === 'karuizawa003' || areaId === 'kaiyukaruizawa') {
        return Constants.LINK_BASE_URL + '/kaiyukaruizawa/services/yobunoru-karuizawa'
      } else {
        return Constants.LINK_BASE_URL + '/tohoku/services/yobunoru-ichinoseki'
      }
    },
    reload: function () {
      this.getReservations()
    },
    showNewReserve: function () {
      const areaId = this.$route.params.areaId || this.$route.params.poiId
      const mobilityId = this.$route.query.mobilityId
      if (mobilityId === 'karuizawa003' || areaId === 'kaiyukaruizawa') {
        if (this.reservations.filter(r => r.status === "PICKING_UP").length === 0) {
          return true
        } else {
          return false
        }
      } else {
        return true
      }
    }
  }
}
</script>
